<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
const props = defineProps({
  name: { type: String, required: true },
  help: { type: String, required: true },
  action: { type: Function, required: true },
  disabled: Boolean,
});
const emit = defineEmits(['deleted', 'busy']);
const { t } = useI18n();
const confirming = ref(false);
const busy = ref(false);
const error = ref('');
async function remove() {
  busy.value = true;
  emit('busy', true);
  error.value = '';
  try {
    await props.action();
  } catch {
    error.value = t('MEDIA_LIBRARY.DELETE_ERROR');
    return;
  } finally {
    busy.value = false;
    emit('busy', false);
  }
  confirming.value = false;
  emit('deleted');
}
</script>

<template>
  <div class="flex flex-col gap-2">
    <Button
      v-if="!confirming"
      color="ruby"
      variant="outline"
      icon="i-lucide-trash-2"
      :label="t('MEDIA_LIBRARY.DELETE')"
      :aria-label="t('MEDIA_LIBRARY.DELETE_NAME', { name })"
      :disabled="disabled"
      @click="confirming = true"
    />
    <div v-else class="flex flex-col gap-2 rounded-lg border border-n-weak p-3">
      <p class="m-0 break-words text-sm font-medium">
        {{ t('MEDIA_LIBRARY.DELETE_NAME', { name }) }}
      </p>
      <p class="m-0 text-sm text-n-slate-11">{{ help }}</p>
      <p v-if="error" role="alert" class="m-0 text-sm text-n-ruby-11">
        {{ error }}
      </p>
      <div class="flex gap-2">
        <Button
          :label="t('MEDIA_LIBRARY.CANCEL')"
          color="slate"
          variant="outline"
          :disabled="busy"
          @click="confirming = false"
        />
        <Button
          :label="t('MEDIA_LIBRARY.DELETE')"
          color="ruby"
          :is-loading="busy"
          :disabled="busy || disabled"
          @click="remove"
        />
      </div>
    </div>
  </div>
</template>
